<template>
  <div id="flight-list">
    <b-message
      v-if="differentAirportSameCity"
      type="is-warning"
    >Your flights contain differing airports for the same city, please take note!</b-message>
    <div class="flight-wrapper-double scroll-border" v-if="!flags.searchInProgress">
      <div class="outbound" :class="{ 'desktop-only': !isEmpty(selectedFlights.outbound) }">
        <div class="selection-prompt">
          <span v-if="this.filteredOutbound.length !== 0">
            Select your
            <b class="primary" v-if="isDomesticReturn">OUTBOUND</b> flight to
          </span>
          {{ outboundSelectionPrompt }},
          <br v-if="isDomesticReturn" class="desktop-only" />
          on {{ formatDate(searchParameters.itineraries[0].departDate) }}
        </div>
      </div>

      <div
        v-if="isDomesticReturn"
        class="return"
        :class="{ 'desktop-only': isEmpty(selectedFlights.outbound) }"
      >
        <div class="selection-prompt">
          <span v-if="!this.filteredReturn.length == 0">
            Select your
            <b class="secondary">RETURN</b> flight to
          </span>
          {{ returnSelectionPrompt }},
          <br class="desktop-only" />
          on {{ formatDate(searchParameters.itineraries[0].returnDate) }}
        </div>
      </div>
    </div>
    <div class="scrollable-list" v-if="flags.searchInProgress && flags.isDomesticReturn">
      <div class="flight-wrapper-double scroll-border">
        <!-- Wait for flights to load -->
        <div class="outbound">
          <div class="selection-prompt-loading">
            <beat-loader :color="beatColor" :size="beatSize"></beat-loader>
            (Awaiting Providers... {{ currentStep }})
          </div>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
        </div>

        <div class="return dekstop-only" v-if="!mobile">
          <div class="selection-prompt-loading">
            <beat-loader :color="beatColor" :size="beatSize"></beat-loader>
            (Awaiting Providers... {{ currentStep }})
          </div>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
          <content-await class="flight-conatiner bigger-right-margin"></content-await>
        </div>
      </div>
    </div>
    <div class="scrollable-list" v-else-if="flags.searchInProgress">
      <div class="flight-wrapper-single scroll-border">
        <!-- Wait for flights to load -->
        <div class="selection-prompt-loading">
          <beat-loader :color="beatColor" :size="beatSize"></beat-loader>
          (Awaiting Providers... {{ currentStep }})
        </div>
        <content-await-large class="flight-conatiner"></content-await-large>
        <content-await-large class="flight-conatiner"></content-await-large>
        <content-await-large class="flight-conatiner"></content-await-large>
        <content-await-large class="flight-conatiner"></content-await-large>
        <content-await-large class="flight-conatiner"></content-await-large>
      </div>
    </div>
    <div class="scrollable-list" v-else>
      <div class="flight-wrapper-single" v-if="!isDomesticReturn">
        <!-- Display oneway and international flights -->
        <div v-for="flight in limit_filteredOutbound" :key="flight.key">
          <flight class="flight-conatiner" :flight-details="flight" direction="outbound" />
        </div>
      </div>
      <div class="flight-wrapper-double" v-else>
        <!-- Display domestic return flights -->
        <div class="outbound" :class="{ 'desktop-only': !isEmpty(selectedFlights.outbound) }">
          <div v-for="flight in limit_filteredOutbound" :key="flight.key">
            <flight class="flight-conatiner" :flight-details="flight" direction="outbound" />
          </div>
        </div>
        <div class="return" :class="{ 'desktop-only': isEmpty(selectedFlights.outbound) }">
          <div v-for="flight in limit_filteredReturn" :key="flight.key">
            <flight class="flight-conatiner" :flight-details="flight" direction="return" />
          </div>
        </div>
      </div>
      <div class="width-100 text-center">
        <b-button
          class="button__show-more"
          type="is-primary"
          size="is-small"
          v-if="!flags.searchInProgress && filteredOutbound.length > 10 || filteredReturn > 10"
          @click="setLimit()"
          outlined
        >{{ limitPrompt }}</b-button>
      </div>
      <b-message
        v-if="(!flags.searchInProgress && filteredOutbound.length < 1)"
        type="is-danger"
      >No flights available, please adjust your search criteria and try again.</b-message>
    </div>
  </div>
</template>

<script>
import Flight from "@/components/Flight.vue";
import { mapState } from "vuex";
import ContentAwait from "@/components/ContentAwait.vue";
import ContentAwaitLarge from "@/components/ContentAwaitLarge.vue";
import moment from "moment";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";

export default {
  name: "flightList",
  computed: {
    ...mapState([
      "searchResults",
      "flags",
      "urlSearchParameters",
      "searchParameters",
      "selectedFlights",
      "filteredOutbound",
      "filteredReturn"
    ]),
    differentAirportSameCity() {
      if (
        this.searchParameters.tripType == "return" &&
        !this.isEmpty(this.selectedFlights.outbound)
      ) {
        if (this.selectedFlights.outbound.odoList.length > 1) {
          let dep = this.selectedFlights.outbound.odoList[0].segments[0];
          let ret = this.selectedFlights.outbound.odoList[1].segments[
            this.selectedFlights.outbound.odoList[1].segments.length - 1
          ];
          let lastSeg = this.selectedFlights.outbound.odoList[0].segments[
            this.selectedFlights.outbound.odoList[0].segments.length - 1
          ];
          let firstSeg = this.selectedFlights.outbound.odoList[1].segments[0];
          if (
            lastSeg.destCode !== firstSeg.origCode ||
            dep.origCode !== ret.destCode
          ) {
            return true;
          }
        }
      }
      return false;
    },
    limit_filteredOutbound() {
      if (this.limit) {
        return this.filteredOutbound.slice(0, this.limit);
      }
      return this.filteredOutbound;
    },
    limit_filteredReturn() {
      if (this.limit) {
        return this.filteredReturn.slice(0, this.limit);
      }
      return this.filteredReturn;
    },
    isDomesticReturn() {
      return this.searchResults.isBundled ? false : true;
    },
    errorMessages() {
      if (!this.flags.searchInProgress) {
        return this.searchResults.errors.map(error => {
          return error.errors[0].message;
        });
      }
      return undefined;
    },
    deaprtureLocationName() {
      if (!this.flags.searchInProgress) {
        let locationObject = this.determineLocationFromCode(
          this.searchParameters.itineraries[0].origin.value.code
        );
        return locationObject
          ? locationObject.airport
          : this.searchParameters.itineraries[0].origin.value.code;
      }
      return undefined;
    },
    detinationLocationName() {
      if (!this.flags.searchInProgress) {
        let lastIndex = this.searchParameters.itineraries.length - 1;
        let locationObject = this.determineLocationFromCode(
          this.searchParameters.itineraries[lastIndex].destination.value.code
        );
        return locationObject
          ? locationObject.airport
          : this.searchParameters.itineraries[lastIndex].destination.value.code;
      }
      return undefined;
    },
    outboundSelectionPrompt() {
      if (!this.flags.searchInProgress) {
        if (this.filteredOutbound.length == 0) {
          return `No Flights Available...`;
        } else {
          return `
            ${this.detinationLocationName} 
            of ${this.filteredOutbound.length} flights`;
        }
      }
      return undefined;
    },
    returnSelectionPrompt() {
      if (!this.flags.searchInProgress) {
        if (this.filteredReturn.length == 0) {
          return `No Flights Available...`;
        } else {
          return `
            ${this.deaprtureLocationName} 
            of ${this.filteredReturn.length} flights`;
        }
      }
      return undefined;
    }
  },
  methods: {
    determineLocationFromCode(code) {
      if (this.searchResults) {
        return this.searchResults.airportInfos.find(e => {
          return e.iataCode == code;
        });
      }
      return undefined;
    },
    setLimit() {
      if (this.limit == 10) {
        this.limit = undefined;
        this.limitPrompt = "Show less results";
      } else {
        this.limit = 10;
        this.limitPrompt = "Show more results";
      }
    },
    isEmpty(obj) {
      for (let key in obj) {
        if (obj.hasOwnProperty(key)) return false;
      }
      return true;
    },
    formatDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    },
    stepCurrentProgress: function() {
      const it = this.progressSteps[Symbol.iterator]();
      const int = setInterval(() => {
        const next = it.next();
        if (!next.done) {
          this.currentStep = next.value;
        } else {
          clearInterval(int);
        }
      }, 1500);
    }
  },
  data: function() {
    return {
      beatSize: "12px",
      beatColor: "#00b6dd",
      currentStep: "Amadeus",
      progressSteps: ["..", "...", "...."],
      limit: 10,
      limitPrompt: "Show more results",
      mobile: window.innerWidth < 781
    };
  },
  mounted() {
    this.stepCurrentProgress();
  },
  components: {
    Flight,
    ContentAwait,
    ContentAwaitLarge,
    BeatLoader
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#flight-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  //   max-height: calc(100vh - 119px);
  //   overflow: hidden;
  border-radius: 8px;
}

.button__show-more {
  margin: auto;
  margin-top: 0.75em;
  margin-bottom: 2em;
}

.width-100 {
  width: 100%;
}

.text-center {
  text-align: center;
}

.primary {
  color: $primary-color;
}

.secondary {
  color: $secondary-color;
}

.scrollable-list {
  //   overflow-y: scroll;
  //   max-height: 100vh;
  //   padding-right: 50px;
  padding-top: 8px;
  //   width: 100%;
  //   box-sizing: content-box;
}

.flight-conatiner {
  margin-bottom: 0.65em;
  margin-left: 0.2em;
  margin-right: 0.2em;
}

.flight-wrapper-single {
  width: 100%;
}

.flight-wrapper-double {
  width: 100%;
}

.selection-prompt {
  color: darken($grey, 40%);
  font-size: 10px;
  padding: 0.8em 0.5em;
}

.selection-prompt-loading {
  color: $secondary-dark;
  font-weight: bold;
  font-size: 12px;
  padding: 0.8em 0.5em;
  display: flex;
  align-items: flex-start;
  .v-spinner {
    margin-right: 0.8em;
  }
}

.scroll-border {
  border-bottom: 1px solid darkgray;
  padding: 0.5em;
}

@media (max-width: 781px) {
  .bigger-right-margin {
    margin-right: 0.75em;
  }
}

@media (min-width: 781px) {
  .flight-wrapper-double {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    grid-auto-rows: minmax(10px, auto);
    grid-column-gap: 1em;
    grid-row-gap: 0.75em;
    grid-template-areas: "outbound return";
  }

  //   .scrollable-list {
  //     padding-left: 5px;
  //   }

  #flight-list {
    display: flex;
    justify-content: flex-start;
  }

  .outbound {
    grid-area: outbound;
  }

  .return {
    grid-area: return;
  }
}
</style>
